<autocomplete-list-item (clicked)="triggerEvent()">
  <div class="header">{{ item.name }}</div>
  <div>{{ item.description }} {{item.additionalDescription}}</div>
  <div *ngIf="item.manufacturerNumber">Hersteller-Nr.: {{ item.manufacturerNumber }}</div>
  <div *ngIf="item.customerNumber">ERP-Artikelnr.: {{ item.customerNumber }}</div>
  <div *ngIf="item.pcn">PZN: {{ item.pcn }}</div>
</autocomplete-list-item>
